import { render, staticRenderFns } from "./ShareWithPeople.vue?vue&type=template&id=6078b483"
import script from "./ShareWithPeople.vue?vue&type=script&lang=js"
export * from "./ShareWithPeople.vue?vue&type=script&lang=js"
import style0 from "./ShareWithPeople.vue?vue&type=style&index=0&id=6078b483&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports